import React from "react";

function Adquirencia() {
  return (
    <div className="home">
      <iframe
        title="Adquirencia"
        class="video"
        widht="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=4ea82f53-fbdb-4919-8ab9-bbafe42b41c6&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Adquirencia;
